import router, { dynamicRoute, homeRoute } from './index'
import { usePort } from '@/hooks/index'
import { useAppRouter, useRouterTravelStore, useUserStore } from '@/store'
import { message } from 'ant-design-vue'
import { RouteRecordRaw, useRouter } from 'vue-router'
import ApppConfig from 'AppConfig'
// import { UserController } from '@/controller'

// const useRouterTravel = useRouterTravelStore()

const hasRoutes = true

router.beforeEach((to, from, next) => {
  document.title = ApppConfig.appName

  const userStore = useUserStore()

  const appRouter = useAppRouter()

  const phone = userStore?.userInfo?.phone

  const token = phone

  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next({ path: '/login' })
    } else {
      // if (appRouter.router.navbar.selectPath === '/health') {
      //   const meuns = userStore.meuns

      //   const roleRoutes = dynamicRoute.filter(item => meuns.find(meun => meun.path === item.path))

      //   userStore.setRoleMeun(roleRoutes)

      //   appRouter.setSiderRoutes()

      //   if (to.path === '/' && hasRoutes) {
      //     next({ ...roleRoutes[0] })
      //   }
      //   if (hasRoutes) {
      //     roleRoutes.forEach(roleRoute => {
      //       router.addRoute('health', roleRoute)
      //     })
      //     next({ ...to, replace: true })
      //     hasRoutes = false
      //   } else {
      //     next()
      //   }
      // } else {
      //   appRouter.setSiderRoutes()

      //   next()
      // }
      appRouter.setSiderRoutes()
      next()
    }
  }
})
